import { render, staticRenderFns } from "./NightCall.vue?vue&type=template&id=4cb3edc6&scoped=true"
import script from "./NightCall.vue?vue&type=script&lang=js"
export * from "./NightCall.vue?vue&type=script&lang=js"
import style0 from "./NightCall.vue?vue&type=style&index=0&id=4cb3edc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb3edc6",
  null
  
)

export default component.exports